import { apiClient } from './api'
import { Transaction } from '@/types'

class TransactionService {
  async getSaleShopTransactions(
    saleShopId: number,
    params: {
      page?: number
      page_size?: number
      search?: string
      status?: string
      payment_method?: string
      start_date?: string
      end_date?: string
    }
  ): Promise<{
    success: boolean
    message: string
    data: {
      results: Transaction[]
      count: number
      next: string | null
      previous: string | null
    }
  }> {
    return apiClient.get(`/transactions/sale-shop/${saleShopId}/`, { params })
  }

  handleError(error: any): string {
    if (error.response?.data?.message) {
      return error.response.data.message
    }
    if (error.message) {
      return error.message
    }
    return 'An error occurred'
  }
}

export const transactionService = new TransactionService()
